import { Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { Club } from '@fable/types'
import { getClubSuggestion } from 'app/clubs/apiHelpers'
import { useClub, useClubMachineState } from 'app/clubs/hooks'
import { AxiosResponse } from 'axios'
import { ClubCard } from 'components/cards'
import { Carousel, useCarouselController } from 'components/carousel'
import { useQuery, useQueryClient, UseQueryResult } from 'react-query'
import { ClubDetailCarouselControls } from './ClubDetailCarouselControls'
import { ClubDetailContainer } from './ClubDetailContainer'

export const ClubDetailSuggestions = ({
  className,
}: {
  className?: string
}) => {
  const { colors, mediaQueries, breakpoints } = useTheme()
  const carouselController = useCarouselController()
  const club = useClub()
  const queryClient = useQueryClient()
  const { machine } = useClubMachineState()

  const clubListQuery: UseQueryResult<AxiosResponse> = useQuery(
    ['club-suggestion'],
    () => getClubSuggestion(club?.current_book?.id)
  )

  const clubData = clubListQuery?.data?.data
  const clubList = clubData?.results as Club[]
  const clubs = clubList?.filter((o) => o.id !== club?.id)

  if (!clubs || !clubs.length) return null

  return (
    <ClubDetailContainer>
      <div className={className}>
        <Text
          className={css`
            margin-bottom: 24px;
            ${mediaQueries.tabletL} {
              margin-bottom: 32px;
            }
          `}
          type="header"
          tag="h2"
          sizing="XS"
          color={colors.graphite}
          text={
            club?.is_dormant
              ? 'Clubs we recommend instead'
              : 'Other clubs that you might like'
          }
        />
        <div
          className={css`
            position: relative;
          `}
        >
          <ClubDetailCarouselControls controller={carouselController} />
          <Carousel
            controller={carouselController}
            options={{
              slides: { perView: 'auto', spacing: 20, origin: 0 },
              breakpoints: {
                [`(min-width: ${breakpoints.tabletL}px)`]: {
                  slides: { perView: 'auto', spacing: 28, origin: 'auto' },
                },
              },
            }}
            childWidths={[
              { width: '208px', breakpoint: 'base' },
              { width: '248px', breakpoint: breakpoints.tabletL },
            ]}
            noOverflow
          >
            {clubs.map((club, i) => (
              <ClubCard
                key={i}
                club={club}
                onCardClick={() => {
                  queryClient.removeQueries({ queryKey: ['club'] })
                  machine.send('RESET')
                }}
              />
            ))}
          </Carousel>
        </div>
      </div>
    </ClubDetailContainer>
  )
}
